


























































































import Vue from 'vue';
import {IJourneyDetails} from "./JourneyDetails";
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Axios from "axios";

@Component({
    components: {'VueDropzone': vue2Dropzone}
})
export default class ManualRefundRequired extends Vue {
    @Prop() details: IJourneyDetails;
    @Prop() refundData: IRefundStatusJourney;
    private currencyFormatter: Intl.NumberFormat;
    private canSubmit: boolean = false;
    private fetching: boolean = false;
    private fetchError: boolean = false;
    private allDone: boolean = false;
    private covidOverride: boolean = false;
    private replacementBookingReference: string = null;

    private dropzoneOptions: object = {
        url: '/tickets/upload',
        thumbnailWidth: 150,
        maxFilesize: 10,
        maxFiles: 10,
        resizeWidth: 1200,
        resizeQuality: 1,
        acceptedFiles: 'image/jpeg,image/png,image/gif',
        headers: {},
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fad fa-ticket'></i> Click or drag/drop your ticket images to upload"
    };

    private uuidMap: object = {};

    submitClaim() {
        this.fetching = true;

        const dataToSend = {
            'Ctr': this.details.bookingReference,
            'Images': Object.values(this.uuidMap)
        };
        const $form = this.$refs.replacementBookingRefForm as HTMLFormElement;
        if (this.needsToProvideReplacement && this.details.bookingReference === this.replacementBookingReference) {
            let $fieldForReplacementCtr = this.$refs.replacementCtrField as HTMLInputElement;
            $fieldForReplacementCtr.setCustomValidity('Cannot be the same as the overarching booking reference');
            $form.reportValidity();
            return;
        } else if (this.needsToProvideReplacement) {
            let $fieldForReplacementCtr = this.$refs.replacementCtrField as HTMLInputElement;
            $fieldForReplacementCtr.setCustomValidity('');
        }

        if (this.needsToProvideReplacement && !$form.reportValidity()) {
            this.fetching = false;
            return;
        } else if (this.needsToProvideReplacement) {
            dataToSend['ReplacementCtr'] = this.replacementBookingReference;
        }
        Axios.post('/tickets/submit-claim', dataToSend, {
            headers: this.dropzoneOptions.headers
        }).then(r => {
            this.fetching = false;
            this.allDone = true;
        }).catch(e => {
            this.fetching = false;
            this.fetchError = true;
            console.error(e);
        });
    }

    uploadsDone() {
        this.canSubmit = this.$refs.dropzone.getAcceptedFiles().length > 0;
    }

    uploadsInProgress() {
        this.canSubmit = false;
    }

    uploadCallback(file, response) {
        this.uuidMap[file.upload["uuid"]] = response;
        console.log('uuidMap is', this.uuidMap);
    }

    get ticketsThatNeedPrinting() {
        const ticketDetails = this.details.JourneyPlannerResults.fareDetails;
        const fromRefundData = this.refundData.tickets;

        return ticketDetails.filter(t => {
            const matchingTicket = fromRefundData.find(
               r => r.isPrinted && r.ticketCode === t.ticketCode &&
                    r.origin === this.uicToNlc(t.fromUIC) &&
                    r.destination === this.uicToNlc(t.toUIC) &&
                    r.routeCode === t.routeCode
            );
            return matchingTicket !== undefined;
        });
    }

    uicToNlc(uic: string): string {
        // Modified regex without lookbehind because Safari 14.x is a piece of shit
        const match = uic.match(/^70(.{4})0?$/);

        if (!match) {
            throw new Error('Invalid UIC format');
        }

        return match[1];
    }

    numAcceptedFiles(): number {
        return Object.keys(this.uuidMap).length;
    }

    get needsToProvideReplacement(): boolean {
        return !this.covidOverride && this.details.JourneyPlannerResults.fareDetails.filter(t => t.advanceBooking === 1).length > 0;
    }

    removeCallback(file, error, xhr) {
        if (this.allDone || this.fetching) {
            return;
        }
        if (file["accepted"] && file["upload"]["uuid"] in this.uuidMap) {
            Axios.post('/tickets/delete/'+this.uuidMap[file["upload"]["uuid"]], null, {
                headers: this.dropzoneOptions.headers
            }).then(r => {
                delete this.uuidMap[file["upload"]["uuid"]];
                if (Object.keys(this.uuidMap).length === 0) {
                    this.canSubmit = false;
                }
            }).catch(e => {
                console.error(e);
            });
        }
    }

    created() {
        this.currencyFormatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        });
    }

    mounted() {
        this.dropzoneOptions.headers['Journey-Id'] = this.refundData.journeyID;
    }
}

